import React from 'react';
import Layout from './../components/shared/Layout';
import Header from './../components/shared/Header';
import DonateDetails from './../components/donate/DonateDetails';

const Donate = () => (
    <Layout title="Donate Today">
        <Header title="Donate Today" page="Donate"/>
        <DonateDetails />
    </Layout>
)

export default Donate;